export const saveCreateProject = (projectDetails, handleClickOpen, setNavigateToProjectList, handleCreate) => {
  const {
    exit,
    clientId,
    projectName,
    projectDescription,
    selectedUseCases,
    selectedJurisdiction,
    selectedDataAggregation,
    selectedFilters,
    setShowNotification,
    setInputDisabled,
    selectedTrendAnalysis,
    selectedChatbot,
    selectedChatbotExport,
    selectedChatbotCopy,
    selectedExportToggle,
    selectedBenefits,
    selectedWorkforces,
    selectedPOI,
    selectedPersona
  } = projectDetails
  const createPayload = {}
  createPayload.clientId = clientId
  createPayload.groupName = projectName.trim()
  createPayload.description = projectDescription
  createPayload.groupType = '3' // hardcoded for viewer
  createPayload.filters = selectedFilters?.map((filter) => filter.FILTER_KEY) || []
  createPayload.jurisdiction = selectedJurisdiction.map((element) => element.STATE_ID)
  createPayload.dataAggregation = selectedDataAggregation?.map((element) => element.key)
  createPayload.trendAnalysisFlag = selectedTrendAnalysis
  createPayload.chatbotFlag = selectedChatbot

  createPayload.chatbotExportFlag = selectedChatbotExport
  createPayload.chatbotCopyFlag = selectedChatbotCopy
  createPayload.exportFlag = selectedExportToggle
  createPayload.benefits = selectedBenefits.map((element) => element.id) || []
  createPayload.workforces = selectedWorkforces.map((element) => element.id) || []
  createPayload.usecase = selectedUseCases || []
  createPayload.personaFlag = selectedPersona
  createPayload.pointOfInterest = selectedPOI.map((element) => element.POI_ID) || []
  const createProjectDetails = {
    setShowNotification,
    exit,
    setNavigateToProjectList,
    setInputDisabled
  }
  handleCreate(createPayload, handleClickOpen, createProjectDetails)
}
